import isIP from 'validator/lib/isIP'

const phoneReg = /^1[3-9]\d{9}$/
export const notEmpty = (tips) => val => (val ? null : tips || '不可为空')
export const isPhone = (tips) => val => (phoneReg.test(val) ? null : tips || '请输入正确的手机号')
export const isIp = (tips) => val => ((isIP(val, 4) || isIP(val, 6)) ? null : tips || '请输入正常的IP地址')
